module.exports = __webpack_public_path__ + "static/img/H31.48a44fc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/q_and_a/H31.png
// module id = ykW+
// module chunks = 0